import { BaseError } from './base.js';
export class InternalError extends BaseError {
    httpStatus = 500;
}
